import { JobType } from '../../../interfaces/job';

export const JOB_MODE_ICON_MAP: { [key in JobType]: string } = {
  [JobType.INCREMENTAL]: 'incremental',
  [JobType.HISTORICAL]: 'history',
  [JobType.TRUNCATE_AND_LOAD]: 'refresh',
  [JobType.REFRESHER]: 'refresh',
  [JobType.STREAMING]: 'real-time'
};
